<template>
    <div>
        <div v-if="pageState === PAGE_STATES.DASHBOARD">
            <component :is="activeComponent" />
        </div>
        <div v-else>
            <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
            <div class="content-wrapper">
                <div class="content">
                    <div v-if="pageState === PAGE_STATES.PAGE_LOADING">
                        <div class="d-flex justify-center align-center">
                            <v-progress-circular indeterminate color="mainNew"></v-progress-circular>
                        </div>
                    </div>
                    <div v-else-if="pageState === PAGE_STATES.ERROR">
                        <div class="d-flex justify-center align-center">
                            <h2>При загрузке данных произошла ошибка</h2>
                        </div>
                    </div>

                    <div v-else-if="pageState === PAGE_STATES.INITIALIZING" class="content mt-12">
                        <div class="d-flex justify-center align-center">
                            <div class="d-flex justify-center align-center" style="flex-direction: column;">
                                <h2>
                                    Изучаем привычки ваших клиентов. Это может занять несколько десятков
                                    минут. Мы напишем вам на e-mail, когда все будет готово.
                                </h2>
                                <div style="width: 400px">
                                    <v-progress-linear
                                        indeterminate
                                        color="mainNew"
                                        class="mt-10"
                                    ></v-progress-linear>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="pageState === PAGE_STATES.DATA_LOADING" class="content mt-12">
                        <div class="d-flex justify-center align-center">
                            <div class="d-flex justify-center align-center" style="flex-direction: column;">
                                <h2>Данные загружаются. Мы напишем вам на e-mail, когда все будет готово.</h2>
                                <div style="width: 400px">
                                    <v-progress-linear
                                        indeterminate
                                        color="mainNew"
                                        class="mt-10"
                                    ></v-progress-linear>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

const GCB2Main = () => import('@/views/GCB2/Main.vue')
const ReturnabilityDashboard = () => import('@/views/GCB2/ReturnabilityDashboard')
const MarketingReport = () => import('@/views/GCB2/MarketingReport')
const SubscribersGrowthReport = () => import('@/views/GCB2/SubscribersGrowthReportView')
const SimpleReports = () => import('@/views/GCB2/SimpleReports')
const WhereIsMyClients = () => import('@/views/GCB2/WhereIsMyClients')
const Kpi = () => import('@/views/GCB2/Kpi')
const ChurnReport = () => import('@/views/GCB2/ChurnReport')
const StaffReport = () => import('@/views/GCB2/StaffReport')
const SameDayRecReport = () => import('@/views/GCB2/SameDayRecReport')
const FourhandsReport = () => import('@/views/GCB2/FourhandsReport')
const PersonaReport = () => import('@/views/GCB2/PersonaReport')
const DoctorReport = () => import('@/modules/DoctorReport/views/DoctorReport.vue')
const DoctorReportLoreal = () => import('@/modules/DoctorReportLoreal/views/DoctorReportLoreal.vue')
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import isNil from 'lodash/isNil'
import { INIT } from '@root/src/store/chisai/GCB2/actionTypes'
import NotFound from '../NotFound.vue'
import { getWhatsappBasisSubsystemStatus } from '@api/chisai/GCB2'
import { useBillingStore } from '@/store/stores/billing'
const AvgCheckReport = () => import('@root/src/modules/AvgCheckReport/views/AvgCheckReport.vue')
const HotWindows = () => import('@root/src/modules/HotWindows/views/HotWindows.vue')

const PAGE_STATES = {
    PAGE_LOADING: 'PAGE_LOADING',
    DASHBOARD: 'DASHBOARD',
    DATA_LOADING: 'DATA_LOADING',
    INITIALIZING: 'INITIALIZING',
    ERROR: 'ERROR',
}
export default {
    name: 'GCB2StartPage',
    components: { Breadcrumbs, ReturnabilityDashboard, GCB2Main, MarketingReport, SimpleReports },
    data: () => ({
        PAGE_STATES,
    }),
    props: {
        dashboardType: {
            type: String,
        },
    },
    computed: {
        project() {
            return this.$store.getters.projectById(this.$route.params.id)
        },
        connector() {
            return this.project.connectors.find(con => con.connectorType === 'GCB2')
        },
        // initChisai/GCB2 и loading обновляются в сторе по realtime-событиям (helpers/projectRealtime)
        pageState() {
            // Если инициализация уже завершена, сразу показываем дашборд
            if (this.project?.initChisai?.GCB2 === true) {
                return PAGE_STATES.DASHBOARD
            }

            const loading = this.project?.loading
            if (isNil(loading)) {
                return PAGE_STATES.PAGE_LOADING
            }
            if (loading.isError) {
                return PAGE_STATES.ERROR
            }
            if (loading.status === true) {
                return PAGE_STATES.DATA_LOADING
            }
            return PAGE_STATES.INITIALIZING
        },
        activeComponent() {
            if (this.dashboardType === 'main') return GCB2Main
            if (this.dashboardType === 'returnability') return ReturnabilityDashboard
            if (this.dashboardType === 'marketingReport') return MarketingReport
            if (this.dashboardType === 'subscribersGrowth') return SubscribersGrowthReport
            if (this.dashboardType === 'simpleReports') return SimpleReports
            if (this.dashboardType === 'kpi') return Kpi
            if (this.dashboardType === 'churn') return ChurnReport
            if (this.dashboardType === 'staff') return StaffReport
            if (this.dashboardType === 'sameDayRec') return SameDayRecReport
            if (this.dashboardType === 'fourhandsReport') return FourhandsReport
            if (this.dashboardType === 'personaReport') return PersonaReport
            if (this.dashboardType === 'doctorReport') return DoctorReport
            if (this.dashboardType === 'avgCheckReport') return AvgCheckReport
            if (this.dashboardType === 'hotWindows') return HotWindows
            if (this.dashboardType === 'whereIsMyClients') return WhereIsMyClients
            if (this.dashboardType === 'doctorReportLoreal') return DoctorReportLoreal
            return NotFound
        },
        breadcrumbs() {
            return [
                {
                    text: 'Ваши проекты',
                    to: '/projects',
                },
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
            ]
        },
    },

    watch: {
        '$route.params.id': {
            immediate: true,
            async handler(projectId) {
                //Если GCB не инициализированн, инициализируем
                if (projectId && !this.connector && this.project.id !== 'loading') {
                    await this.$store.dispatch(`GCB2/${INIT}`, projectId)
                }
            },
        },
    },
    async created() {
        const billingStore = useBillingStore()
        if (this.project.billingEnabled)
            await Promise.all([
                billingStore.fetchCurrentTariff(this.project.id),
                billingStore.fetchTariffs(this.project.id),
            ])
        if (!this.$store.state.whatsappStatus) {
            const data = await getWhatsappBasisSubsystemStatus(this.project.id)
            this.$store.state.whatsappStatus = data.data
        }
    },
}
</script>
<style lang="sass" scoped></style>
